<template>
  <div id="app">
    <div class="bg">
      <div class="topBar"></div>
      <header-bar :page-name="'safehome'" :icon-color="'#7b7a7a'" class="headBar" facebookShareURL="https://udn.com/newmedia/921/safehome/" lineShareURL="https://udn.com/newmedia/921/safehome/"></header-bar>
      <div class="progress" v-if="isProgress">
        <div class="progress_container"></div>
      </div>
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :bar="bar"/>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"/> -->
      <router-view :bar="bar"/>
    </div>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <router-view/> -->
  </div>
</template>

<script>
import HeaderBar from '../../general_components/HeaderBar.vue'

export default {
  name: 'app',
  computed: {
    isWeb(){
      if(window.innerWidth >= 768){
        return true
      }
      return false
    },
    isProgress(){
      return this.$store.state.isProgress
    }
  },
  components: {
    HeaderBar
  },
  data() {
    return {
      bar: null
    }
  },
  methods:{

  },
  mounted() {
    var bar = new ProgressBar.Circle('.progress_container', {
    strokeWidth: 3,
    easing: 'easeOut',
    duration: 1500,
    color: '#57af9f',
    trailColor: '#eee',
    trailWidth: 3,
    svgStyle: null,
    text: {
      value: '0/5',
      style: {
        color: '#fff',
        position: 'absolute',
        left: '50%',
        top: '50%',
        padding: 0,
        margin: 0,
        transform: {
          prefix: true,
          value: 'translate(-50%, -50%)'
        }
      }
    }
    });

    this.bar = bar
    this.bar._container.parentNode.style.opacity = 0
    // bar.animate();  // Number from 0.0 to 1.0
  }
}
</script>

<style lang="sass">
html, body
  margin: 0
  padding: 0
.bg
  // overflow: auto
  // position: fixed
  width: 100%
  background-image: url('../public/static/image/home_mob.jpg')
  background-repeat: repeat-y
  background-size: cover
  @media (min-width: 768px)
    background-image: url('../public/static/image/home_web.jpg')
    background-size: 100%
.progress
  width: 60px
  height: 60px
  background: #737373
  position: fixed
  left: 50%
  transform: translateX(-50%)
  top: 8px
  z-index: 101
  border-radius: 50%
  display: flex
  justify-content: center
  align-items: center
  opacity: 0
  @media (min-width: 768px) 
    top: 58px
.progress_container
  width: 50px
  height: 50px
.progress_number
  position: absolute
  color: #fff
// .progress_circle
//   border: 2px solid #fff
//   width: 50px
//   height: 50px
//   border-radius: 50%
//   display: flex
//   justify-content: center
//   align-items: center
//   color: #fff
.topBar
  position: fixed
  width: 100%
  height: 50px
  left: 0
  top: 0
</style>
